import { motion } from "framer-motion";
import { Copy, Check } from "lucide-react";

const dateFmt = (iso) =>
  new Date(iso).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const MessageCard = ({ message: m, index: i, copied, onCopy }) => (
  <motion.article
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: Math.min(i * 0.03, 0.4) }}
    className="border border-stroke bg-matte p-6 md:p-8"
    data-testid={`admin-message-${i}`}
  >
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12 md:col-span-3">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-laser">
          {dateFmt(m.created_at)}
        </div>
        <div className="mt-3 font-serif font-light text-xl text-ink leading-tight">{m.name}</div>
        {m.company && (
          <div className="mt-1 font-mono text-[10px] tracking-[0.24em] uppercase text-steel">
            {m.company}
          </div>
        )}
        <button
          onClick={() => onCopy(m.id, m.email)}
          data-testid={`admin-copy-${i}`}
          className="mt-3 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-steel hover:text-laser transition-colors"
        >
          {copied ? <Check size={12} strokeWidth={1.5} /> : <Copy size={12} strokeWidth={1.5} />}
          {m.email}
        </button>
        <div className="mt-3">
          <span
            className={`inline-block font-mono text-[10px] tracking-[0.2em] uppercase px-2 py-1 border ${
              m.email_sent ? "border-laser/60 text-laser" : "border-stroke text-steel"
            }`}
          >
            {m.email_sent ? "Emailed" : "Saved only"}
          </span>
        </div>
      </div>
      <div className="col-span-12 md:col-span-9 md:border-l md:border-stroke md:pl-8">
        <p className="font-sans text-base text-ink/90 leading-relaxed whitespace-pre-wrap">
          {m.message}
        </p>
      </div>
    </div>
  </motion.article>
);
